"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bedbankCalendar = exports.bedbankReservation = exports.bedbankEnquiry = void 0;
exports.bedbankEnquiry = "/api/bedbank/reservations/enquiry";
exports.bedbankReservation = "/api/bedbank/reservations";
exports.bedbankCalendar = "/api/bedbank/properties/{propertyId}/calendar{?region,brand,nights,roomId}";
